import { storeToRefs } from 'pinia'
import { onMounted, watch } from 'vue'
import { useRouter } from 'vue-router'

import { useAuthStore } from '@/auth/useAuthStore'

export const useRedirectIfLoggedIn = (): void => {
  const { isAuthenticated, home } = storeToRefs(useAuthStore())
  const router = useRouter()

  watch(isAuthenticated, async () => {
    if (isAuthenticated.value) {
      await router.replace(home.value)
    }
  })

  onMounted(async () => {
    if (isAuthenticated.value) {
      await router.replace(home.value)
    }
  })
}
